export enum SubjectActivationStatus {
  Activated = 0,
  InvitationSent = 2,
  PendingInvitation = 3,
  ActivationResent = 1,
  Unknown = -1,
}
